import { Box, Paper } from '@mui/material'
import { type ReactNode } from 'react'
import { CardTitle } from './CardTitle'
import { cardChrome } from './cardChrome'

export const SectionCard = ({ title, children, testId }: { title: string, children: ReactNode, testId?: string }): JSX.Element => (
  <Paper elevation={0} sx={cardChrome} data-testid={testId}>
    <Box sx={{ mb: '16px' }}>
      <CardTitle>{title}</CardTitle>
    </Box>
    {children}
  </Paper>
)
